import React from 'react';
import { useNavigate } from 'react-router-dom';


const LocationNotFound = ({ locationId }) => {
  const navigate = useNavigate();

  return (
    <div className="background-section" style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: '48px', marginBottom: '20px', fontWeight: '700' }}>Oops!</h1>
        <h2 style={{ fontSize: '24px', marginBottom: '15px', fontWeight: '600' }}>Location Not Found</h2>
        <p style={{ fontSize: '16px', marginBottom: '30px', color: 'var(--font-color)', lineHeight: '1.6' }}>
          We couldn't find the location you're looking for. Please check the URL and try again.
        </p>
        
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button 
            className="btn btn-primary" 
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer', padding: '10px 20px', fontSize: '16px' }}
          >
            Go to Home
          </button>
          <button 
            className="btn btn-secondary" 
            onClick={() => window.history.back()}
            style={{ cursor: 'pointer', padding: '10px 20px', fontSize: '16px' }}
          >
            Go Back
          </button>
        </div>

        <p style={{ fontSize: '12px', marginTop: '40px', color: 'var(--second-font-color)' }}>
          Location ID: {locationId}
        </p>
      </div>
    </div>
  );
};

export default LocationNotFound;
